/* istanbul ignore file */
export const WIDGET_SOCIAL_META_TYPE = 'meta-social';
